module.exports = __webpack_public_path__ + "./images/f8d054642a3140fe3b021daadb6ffe01.jpg";